import React, { Fragment, useState } from 'react';
import { Popover, Transition } from '@headlessui/react';
import {NavLink, useNavigate} from 'react-router-dom';
import {signOut} from 'firebase/auth';
import {auth} from '../config/firebaseConfig';
import {
  ChevronDoubleDownIcon,
  Bars3Icon,
  XMarkIcon,
  ArrowLeftOnRectangleIcon
} from '@heroicons/react/24/outline';
import { UserAuth } from '../App';

function Navbar({activePage}) {
  const [fix, setFix] = useState(false);
  const {user} = UserAuth();

  const navigate = useNavigate();

    async function logOut() {
        signOut(auth);
        console.log("Cierro Sesión");
        navigate("/")
    }

  function setFixed() {
    if (window.scrollY >= 10){
      setFix(true);
    } else {
      setFix(false);
    }
  }

  window.addEventListener("scroll", setFixed) 
  return (
    <div className="relative z-50">
      <Popover className={fix ? "fixed w-full bg-white my-0 drop-shadow-shad" : "fixed w-full bg-white my-0"}>
      <div className="mx-auto px-4 sm:px-8">
        <div className="flex items-center justify-between py-3 md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <NavLink to="/">
              <span className="sr-only">Laboratorio Santa Bárbara</span>
              <img
                className="h-8 w-auto sm:h-10 scale-125 md:scale-150"
                src="logo.png"
                alt=""
              />
            </NavLink>
          </div>
          <div className="-my-2 -mr-2 md:hidden">
            <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-primary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-100">
              <span className="sr-only">Open menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </Popover.Button>
          </div>

          <Popover.Group as="nav" className="hidden space-x-10 md:flex">
            <NavLink to="/" className={`text-sm lg:text-base font-medium  ${activePage === "/" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
              INICIO
            </NavLink>

            <NavLink to="/AboutUs" className={`text-sm lg:text-base font-medium  ${activePage === "/AboutUs" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
              NOSOTROS
            </NavLink>
            <NavLink to="/Services" className={`text-sm lg:text-base font-medium  ${activePage === "/Services" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
              SERVICIOS
            </NavLink>
            <NavLink to="/News" className={`text-sm lg:text-base font-medium  ${activePage === "/News" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
              NOTICIAS
            </NavLink>
            {/*<NavLink to="/AppointmentRequest" className={`${user? "block" : "hidden"} text-sm lg:text-base font-medium  ${activePage === "/AppointmentRequest" ? "text-primary-100" : "text-navFont-100"}`}>
                CITAS
            </NavLink>*/}
            <NavLink to="/Tests" className={`${user? "block" : "hidden"} text-sm lg:text-base font-medium  ${activePage === "/Tests" ? "text-primary-100" : "text-navFont-100"}`}>
                HISTORIAL
            </NavLink>
          </Popover.Group>
          
          <div className="hidden items-center justify-end md:flex md:flex-1 lg:w-0">
            {user? 
              <div className="-my-2 -mr-2 items-center justify-end md:flex md:flex-1 lg:w-0">
                  <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-primary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-100">
                  <span className="sr-only">Open menu</span>
                  <ChevronDoubleDownIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
              </div> 
              : 
              <NavLink
                to="/Login"
                className="ml-8 inline-flex items-center justify-center whitespace-nowrap rounded-md border 
                          border-transparent bg-primary-100 px-4 py-2 text-base font-medium text-white 
                          shadow-sm hover:bg-primary-200"
              >
                Ingresar
              </NavLink>}
          </div>
        </div>
      </div>

      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        { user?
          <Popover.Panel focus className="absolute w-full md:w-96 right-0 top-0 transform p-2 transition z-20">
          <div className="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="px-5 pt-5 pb-6">
              <div className="flex items-center justify-between">
                  <div className="-mr-2 absolute right-7">
                  <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-primary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-100">
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                  </div>
              </div>
              </div>

              <div className="space-y-6 py-6 px-5">
                  <div className="grid grid-cols-1 gap-y-4 gap-x-8 text-center">
                  <NavLink to="/" className={`md:hidden text-base font-bold ${activePage === "/" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                    INICIO
                  </NavLink>

                  <NavLink to="/AboutUs" className={`md:hidden text-base font-bold  ${activePage === "/AboutUs" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                    NOSOTROS
                  </NavLink>
                  
                  <NavLink to="/Services" className={`md:hidden text-base font-bold  ${activePage === "/Services" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                    SERVICIOS
                  </NavLink>

                  <NavLink to="/News" className={`md:hidden text-base font-bold  ${activePage === "/News" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                    NOTICIAS
                  </NavLink>
                  {/*<NavLink to="/AppointmentRequest" className={`${user? "block" : "hidden"} md:hidden text-base font-bold  ${activePage === "/AppointmentRequest" ? "text-primary-100" : "text-navFont-100"}`}>
                    CITAS
                  </NavLink>*/}
                  <NavLink to="/Tests" className={`${user? "block" : "hidden"} md:hidden text-base font-bold  ${activePage === "/Tests" ? "text-primary-100" : "text-navFont-100"}`}>
                    HISTORIAL
                  </NavLink>
                  
                  <NavLink to="/MyProfile" className={`${user? "block" : "hidden"} text-base font-bold  ${activePage === "/MyProfile" ? "text-primary-100" : "text-navFont-100"}`}>
                      MI PERFIL
                  </NavLink>
                  </div>

                  <div className="grid grid-cols-1 gap-y-4 gap-x-8 text-center">
                      <button onClick={logOut} className="flex flex-row text-base justify-center font-bold text-navFont-100 hover:text-primary-100">
                      <ArrowLeftOnRectangleIcon className='h-6 w-6 mr-2' aria-hidden='true'/>
                      CERRAR SESIÓN
                      </button>
                  </div>
              </div>
          </div>
          </Popover.Panel>
        :
        <Popover.Panel focus className="absolute inset-x-0 top-0 origin-top-right transform p-2 transition">
        <div className="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
          <div className="px-5 pt-5 pb-6">
            <div className="flex items-center justify-between">
              <div>
                <img
                  className="h-8 w-auto"
                  src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                  alt="Your Company"
                />
              </div>
              <div className="-mr-2">
                <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-primary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-100">
                  <span className="sr-only">Close menu</span>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </Popover.Button>
              </div>
            </div>
          </div>

          <div className="space-y-6 py-6 px-5">
            <div className="grid grid-cols-1 gap-y-4 gap-x-8 text-center">
              <NavLink to="/" className={`text-base font-bold ${activePage === "/" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                INICIO
              </NavLink>

              <NavLink to="/AboutUs" className={`text-base font-bold  ${activePage === "/AboutUs" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                NOSOTROS
              </NavLink>
              
              <NavLink to="/Services" className={`text-base font-bold  ${activePage === "/Services" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                SERVICIOS
              </NavLink>

              <NavLink to="/News" className={`text-base font-bold  ${activePage === "/News" ? "text-primary-100" : "text-navFont-100"} hover:text-primary-100`}>
                NOTICIAS
              </NavLink>
              <NavLink to="/AppointmentRequest" className={`${user? "block" : "hidden"} text-base font-bold  ${activePage === "/AppointmentRequest" ? "text-primary-100" : "text-navFont-100"}`}>
                CITAS
              </NavLink>
              <NavLink to="/Tests" className={`${user? "block" : "hidden"} text-base font-bold  ${activePage === "/Tests" ? "text-primary-100" : "text-navFont-100"}`}>
                  HISTORIAL
              </NavLink>
            </div>
            <div>
              <NavLink
                to="/Login"
                className="flex w-full items-center justify-center rounded-md border border-transparent bg-primary-100 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-primary-200"
              >
                Ingresar
              </NavLink>
            </div>
            <div className={`${user? "grid" : "hidden"} grid-cols-1 gap-y-4 gap-x-8 text-center`}>
                <button onClick={logOut} className="flex flex-row text-base justify-center font-bold text-navFont-100 hover:text-primary-100">
                <ArrowLeftOnRectangleIcon className='h-6 w-6 mr-2' aria-hidden='true'/>
                CERRAR SESIÓN
                </button>
            </div>
          </div>
        </div>
      </Popover.Panel>
      }

      </Transition>
    </Popover>
  </div>
  )
}

export default Navbar
